import { productDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { css } from "styled-components";

productDescriptionStyles.productDetailDescription = {
    css: css`
        overflow-wrap: break-word;
        word-break: break-word;
    `
}

productDescriptionStyles.productDetailLink = {
    css: css`
        overflow-wrap: break-word;
        word-break: break-word;
    `
}

productDescriptionStyles.productDetailLink.typographyProps = {
    color: "#003049 !important",
}